import { twMerge } from "tailwind-merge";

import { InfoIcon } from "../SvgIcons/InfoIcon";

interface WarningMessageProps {
  text: string;
  icon?: React.ReactNode;
  containerClassName?: string;
  defaultIconClassName?: string;
  textClassName?: string;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({
  text,
  icon,
  containerClassName,
  textClassName,
  defaultIconClassName,
}) => {
  return (
    <div
      className={twMerge(
        "flex items-center gap-1.5 pl-4 pr-5 py-2.5 bg-red-100/50",
        containerClassName
      )}
    >
      <div className="flex justify-center items-center">
        {icon || (
          <InfoIcon
            className={twMerge(
              "w-5 h-5 [&>path]:fill-red-FF0000 [&>circle]:fill-red-FF0000",
              defaultIconClassName
            )}
          />
        )}
      </div>
      <div
        className={twMerge(
          "text-red-FF0000 font-bold text-[15px]",
          textClassName
        )}
      >
        {text}
      </div>
    </div>
  );
};
